module.exports = __webpack_public_path__ + "static/media/stripe_logo.fd1d6340.png";